module.exports = __webpack_public_path__ + "img/NR0001.be7dde0.jpg";